const columns = [
  {
    title: '内容分类',
    links: [
      { label: '最新电影', href: '#movies' },
      { label: '热门剧集', href: '#series' },
      { label: '分类片库', href: '#category' },
      { label: '编辑精选', href: '#rank' },
    ],
  },
  {
    title: '使用帮助',
    links: [
      { label: '观影指南', href: '#guide' },
      { label: '本周更新日历', href: '#updates' },
      { label: '常见问题', href: '#faq' },
      { label: '关于本站', href: '#about' },
    ],
  },
];

const hotGenres = ['科幻', '悬疑', '古装', '都市', '动画', '爱情'];

export default function SiteFooter() {
  return (
    <footer className="bg-secondary-100 border-t border-secondary-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="sm:col-span-2 lg:col-span-1">
            <a href="#home" className="flex items-center gap-2 cursor-pointer">
              <span className="w-9 h-9 rounded-lg bg-primary-500 text-background-50 flex items-center justify-center">
                <i className="ri-movie-2-line text-xl"></i>
              </span>
              <span className="font-heading text-lg font-bold text-foreground-950">星辰影院</span>
            </a>
            <p className="text-xs md:text-sm text-secondary-900/80 leading-relaxed mt-4 max-w-sm">
              聚合最新电影与热门电视剧资源，支持在线免费观看，画质高清、更新及时。
              想追新剧还是补经典老片，都能在这里快速找到流畅播放源。
            </p>
          </div>

          {columns.map((col) => (
            <div key={col.title}>
              <h4 className="font-heading text-sm font-bold text-foreground-950 mb-4">
                <a href="#home" className="cursor-pointer">
                  {col.title}
                </a>
              </h4>
              <ul className="space-y-2.5">
                {col.links.map((link) => (
                  <li key={link.href}>
                    <a
                      href={link.href}
                      className="text-xs md:text-sm text-secondary-900/80 hover:text-primary-600 transition-colors cursor-pointer"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div>
            <h4 className="font-heading text-sm font-bold text-foreground-950 mb-4">
              <a href="#category" className="cursor-pointer">
                热门类型
              </a>
            </h4>
            <div className="flex flex-wrap gap-2">
              {hotGenres.map((genre) => (
                <a
                  key={genre}
                  href="#category"
                  className="px-3 py-1.5 rounded-full bg-background-50 text-xs text-secondary-900 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                >
                  {genre}
                </a>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-secondary-200 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-secondary-900/70 text-center sm:text-left">
            © 2026 星辰影院 · 本站仅为影视信息的整理与展示页面，不提供任何影音文件存储服务。
          </p>
          <div className="flex items-center gap-4 text-xs text-secondary-900/70">
            <span className="inline-flex items-center gap-1.5">
              <i className="ri-server-line"></i>
              信息聚合展示
            </span>
            <span className="inline-flex items-center gap-1.5">
              <i className="ri-shield-check-line"></i>
              免责声明已公示
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}